import { render, staticRenderFns } from "./ConfirmComponent.vue?vue&type=template&id=73981b24&scoped=true&"
import script from "./ConfirmComponent.vue?vue&type=script&lang=js&"
export * from "./ConfirmComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmComponent.vue?vue&type=style&index=0&id=73981b24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73981b24",
  null
  
)

export default component.exports